import api, {
	ApiLoginResponseSuccess,
	ApiOAuthTokenResponseSuccess,
	ApiOauthUrlResponseSuccess,
	LoginParams,
	OtpSendParams,
	OtpSendResponse,
	OtpVerifyParams,
	OtpVerifyResponse,
} from '.';

export const login = async (data?: LoginParams) =>
	await api.post<ApiLoginResponseSuccess>('/auth/login', data);

export const logout = async () =>
	await api.post<ApiLoginResponseSuccess>('/auth/logout');

/** Refresh token (BE resets token/session). Returns new accessToken if BE issues one. */
export const refreshToken = async () => await api.post<string>('/auth/refresh');

export const oauthLogin = async (code: string, state: string) =>
	await api.get<ApiOAuthTokenResponseSuccess>(
		'/oauth/callback?code=' + code + '&state=' + state
	);

export const getOauthURL = async () =>
	await api.get<ApiOauthUrlResponseSuccess>('/oauth/url');

export const getGpkiURL = async () =>
	await api.get<ApiOauthUrlResponseSuccess>('/oauth/gpkiUrl');

// OTP APIs
export const sendOtp = async ({ preAuthToken }: OtpSendParams) =>
	await api.post<OtpSendResponse>(
		'/auth/otp/send',
		{},
		{
			headers: {
				Authorization: `Bearer ${preAuthToken}`,
			},
		}
	);

export const verifyOtp = async ({ preAuthToken, otpValue }: OtpVerifyParams) =>
	await api.post<OtpVerifyResponse>(
		'/auth/otp/verify',
		{ otpValue },
		{
			headers: {
				Authorization: `Bearer ${preAuthToken}`,
			},
		}
	);
